// src/modules/accounting/routes.jsx
import { Routes, Route, Navigate } from 'react-router-dom';
import AccountingPage from './pages/AccountingPage';
import AccountingSection from './pages/AccountingSection';
import { ACCOUNTING_SECTIONS } from './sections';

const AccountingRoutes = () => (
  <Routes>
    {/* Dashboard grid landing page */}
    <Route path="/" element={<AccountingPage />} />

    {/* One route per section */}
    {ACCOUNTING_SECTIONS.map((section) => (
      <Route
        key={section.key}
        path={section.path}
        element={<AccountingSection section={section} />}
      />
    ))}

    {/* Back-compat alias for the old chart-of-accounts entry point */}
    <Route path="accounts" element={<Navigate to="/accounting/chart-of-accounts" replace />} />

    {/* Unknown paths fall back to the grid */}
    <Route path="*" element={<Navigate to="/accounting" replace />} />
  </Routes>
);

export default AccountingRoutes;
